import {URLS} from "./urls";
import instance from "./axiosInstance";


const fetcher = {
    getCSRFCookie: () => instance.get(URLS.getCSRFCookie()),
    logError: (data) => instance.post(URLS.logError(), data),

    // Notifications
    getNotifications: (params = '') => instance.get(URLS.getNotifications(params)),
    getNotificationsSummary: () => instance.get(URLS.getNotificationsSummary()),
    updateNotification: (id, data) => instance.patch(URLS.updateNotification(id), data),
    markNotificationsRead: (data = {}) => instance.post(URLS.markNotificationsRead(), data),

    // Accounts
    login: (email, password) => instance.post(URLS.login(), { email, password }),
    logout: () => instance.post(URLS.logout()),
    refreshToken: (token) => instance.post(URLS.refreshToken(), { token }),
    getDefaultQuoteSettings: () => instance.get(URLS.getDefaultQuoteSettings()),
    changePassword: (data) => instance.post(URLS.changePassword(), data),
    requestPasswordReset: (email) => instance.post(URLS.requestPasswordReset(), { email }),
    confirmPasswordReset: (data) => instance.post(URLS.confirmPasswordReset(), data),
    updateDefaultQuoteSettings: (data) => instance.post(URLS.updateDefaultQuoteSettings(), data),

    // Cars
    makesForYear: (isUsed) => instance.get(URLS.makesForYear(isUsed)),
    modelsForMake: (year, make, isUsed) => instance.get(URLS.modelsForMake(year, make, isUsed)),
    trimsForModel: (year, make, model, isUsed) => instance.get(URLS.trimsForModel(year, make, model, isUsed)),
    getCarByVin: (vin, isUsed) => instance.get(URLS.getCarByVin(vin, isUsed)),

    // Pricings
    getPricingsForMake: (make, params = '') => instance.get(URLS.getPricingsForMake(make, params)),
    createPricing: (data) => instance.post(URLS.createPricing(), data),
    updatePricing: (id, data) => instance.patch(URLS.updatePricing(id), data),
    deletePricing: (id) => instance.delete(URLS.deletePricing(id)),

    // Deals
    getDeal: (id, params = '') => instance.get(URLS.getDeal(id, params)),
    getDeals: (params = '') => instance.get(URLS.getDeals(params)),
    createDeal: (data) => instance.post(URLS.createDeal(), data),
    updateDeal: (id, data) => instance.patch(URLS.updateDeal(id), data),
    deleteDeal: (id) => instance.delete(URLS.deleteDeal(id)),
    getPDF: (id) => instance.get(URLS.getPDF(id)),
    getDealListings: (id, params = '') => instance.get(URLS.getDealListings(id, params)),
    getTaxRegions: (zipcode) => instance.get(URLS.getTaxRegions(zipcode)),

    // Desking
    getDesking: (data) => instance.post(URLS.getDesking(), data),
    getRebates: (data) => instance.post(URLS.getRebates(), data),
    getRebateCompatibilities: (data) => instance.post(URLS.getRebateCompatibilities(), data),
    getRebate: (rebateId) => instance.get(URLS.getRebate(rebateId)),

    // Listings
    getListings: (data) => instance.post(URLS.getListings(), data),
    getListing: (id) => instance.get(URLS.getListing(id)),
    searchCars: (data) => instance.post(URLS.searchCars(), data),
    suggestListings: (q) => instance.get(URLS.suggestListings(q)),

    // Saved Dealerships
    getSavedDealerships: () => instance.get(URLS.getSavedDealerships()),
    searchDealerships: (params = '') => instance.get(URLS.searchDealerships(params)),
    saveDealership: (data) => instance.post(URLS.saveDealership(), data),
    deleteSavedDealership: (id) => instance.delete(URLS.deleteSavedDealership(id)),

    // Profile
    getProfile: () => instance.get(URLS.getProfile()),
    getLocations: () => instance.get(URLS.getLocations()),
    createLocation: (data) => instance.post(URLS.createLocation(), data),
    updateLocation: (id, data) => instance.patch(URLS.updateLocation(id), data),
    deleteLocation: (id) => instance.delete(URLS.deleteLocation(id)),

    updateProfile: (data) => instance.patch(URLS.updateProfile(), data),
    uploadAccountLogo: (data, config) => instance.post(URLS.accountLogo(), data, config),
    removeAccountLogo: () => instance.delete(URLS.accountLogo()),

    // Leads
    getLead: (id, params = '') => instance.get(URLS.getLead(id, params)),
    getLeads: (params = '') => instance.get(URLS.getLeads(params)),
    createLead: (data) => instance.post(URLS.createLead(), data),
    updateLead: (id, data) => instance.patch(URLS.updateLead(id), data),
    deleteLead: (id) => instance.delete(URLS.deleteLead(id)),
    uploadLeadsCSV: (data, config) => instance.post(URLS.uploadLeadsCSV(), data, config),
    bulkUploadLeads: (data, config) => instance.post(URLS.bulkUploadLeads(), data, config),
    // Blob, not JSON: the response is a CSV file. It still goes through the
    // authenticated instance, so a plain <a href> would not work.
    exportLeads: () => instance.get(URLS.exportLeads(), { responseType: 'blob' }),

    // Clients
    getClient: (id, params = '') => instance.get(URLS.getClient(id, params)),
    getClients: (params = '') => instance.get(URLS.getClients(params)),
    createClient: (data) => instance.post(URLS.createClient(), data),
    updateClient: (id, data) => instance.patch(URLS.updateClient(id), data),
    deleteClient: (id) => instance.delete(URLS.deleteClient(id)),
    bulkUploadClients: (data, config) => instance.post(URLS.bulkUploadClients(), data, config),
    exportClients: () => instance.get(URLS.exportClients(), { responseType: 'blob' }),

    // Emails
    createEmail: (data) => instance.post(URLS.createEmail(), data),

    // CRM — Person / Opportunity / Stage
    getCrmPeople: (params = '') => instance.get(URLS.getCrmPeople(params)),
    getCrmPerson: (id) => instance.get(URLS.getCrmPerson(id)),
    createCrmPerson: (data) => instance.post(URLS.createCrmPerson(), data),
    updateCrmPerson: (id, data) => instance.patch(URLS.updateCrmPerson(id), data),
    deleteCrmPerson: (id) => instance.delete(URLS.deleteCrmPerson(id)),
    bulkDeleteCrmPeople: (personIds) => instance.post(URLS.bulkDeleteCrmPeople(), { person_ids: personIds }),
    bulkMarkDeadCrmPeople: (personIds) => instance.post(URLS.bulkMarkDeadCrmPeople(), { person_ids: personIds }),
    getCrmHouseholds: (params = '') => instance.get(URLS.getCrmHouseholds(params)),
    createCrmHousehold: (data) => instance.post(URLS.createCrmHousehold(), data),
    addCrmHouseholdMembers: (id, personIds) => instance.post(URLS.addCrmHouseholdMembers(id), { person_ids: personIds }),
    removeCrmHouseholdMembers: (id, personIds) => instance.post(URLS.removeCrmHouseholdMembers(id), { person_ids: personIds }),
    getCrmHousehold: (id) => instance.get(URLS.crmHousehold(id)),
    updateCrmHousehold: (id, data) => instance.patch(URLS.crmHousehold(id), data),
    deleteCrmHousehold: (id) => instance.delete(URLS.crmHousehold(id)),

    getCrmStages: () => instance.get(URLS.getCrmStages()),
    createCrmStage: (data) => instance.post(URLS.createCrmStage(), data),
    updateCrmStage: (id, data) => instance.patch(URLS.updateCrmStage(id), data),
    deleteCrmStage: (id) => instance.delete(URLS.deleteCrmStage(id)),
    reorderCrmStages: (order) => instance.post(URLS.reorderCrmStages(), { order }),

    // Legacy-CRM data migration. Preview plans and writes nothing; commit needs
    // the token preview returned. Neither touches the legacy bulk_upload
    // endpoints, which write into the old CRM.
    previewCrmImport: (data) => instance.post(URLS.previewCrmImport(), data),
    commitCrmImport: (data) => instance.post(URLS.commitCrmImport(), data),

    getCrmReports: (params = '') => instance.get(URLS.getCrmReports(params)),
    getCrmSettings: () => instance.get(URLS.getCrmSettings()),
    updateCrmSettings: (data) => instance.patch(URLS.getCrmSettings(), data),
    runCrmRenewals: () => instance.post(URLS.runCrmRenewals()),

    getCrmOpportunities: (params = '') => instance.get(URLS.getCrmOpportunities(params)),
    getCrmOpportunityCounts: (params = '') => instance.get(URLS.getCrmOpportunityCounts(params)),
    getCrmOpportunity: (id) => instance.get(URLS.getCrmOpportunity(id)),
    createCrmOpportunity: (data) => instance.post(URLS.createCrmOpportunity(), data),
    updateCrmOpportunity: (id, data) => instance.patch(URLS.updateCrmOpportunity(id), data),
    // { stage, above, below }: the cards it was dropped between; neither is the top.
    moveCrmOpportunity: (id, data) => instance.post(URLS.moveCrmOpportunity(id), data),
    deleteCrmOpportunity: (id) => instance.delete(URLS.deleteCrmOpportunity(id)),
    attachCrmQuote: (id, dealId) => instance.post(URLS.attachCrmQuote(id), { deal_id: dealId }),
    removeCrmOpportunityVehicle: (id) => instance.post(URLS.removeCrmOpportunityVehicle(id)),
    reverseCrmOpportunitySale: (id) => instance.post(URLS.reverseCrmOpportunitySale(id)),
    editCrmOpportunitySale: (id, data) => instance.post(URLS.editCrmOpportunitySale(id), data),
    deleteCrmOpportunitySale: (id, data) => instance.post(URLS.deleteCrmOpportunitySale(id), data),
    purchaseCrmOpportunityVehicle: (id, data) => instance.post(URLS.purchaseCrmOpportunityVehicle(id), data),

    getCrmVehicles: (params = '') => instance.get(URLS.getCrmVehicles(params)),
    createCrmVehicle: (data) => instance.post(URLS.createCrmVehicle(), data),
    updateCrmVehicle: (id, data) => instance.patch(URLS.updateCrmVehicle(id), data),
    deleteCrmVehicle: (id) => instance.delete(URLS.deleteCrmVehicle(id)),
    purchaseCrmVehicle: (id, data) => instance.post(URLS.purchaseCrmVehicle(id), data),

    getCrmActivities: (params = '') => instance.get(URLS.getCrmActivities(params)),
    createCrmActivity: (data) => instance.post(URLS.createCrmActivity(), data),
    deleteCrmActivity: (id) => instance.delete(URLS.deleteCrmActivity(id)),
}

export default fetcher